import { render, staticRenderFns } from "./EthereumUnavailable.vue?vue&type=template&id=4e64c7fc&scoped=true&"
import script from "./EthereumUnavailable.vue?vue&type=script&lang=js&"
export * from "./EthereumUnavailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64c7fc",
  null
  
)

export default component.exports